import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { fontPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useclockstore } from '../../../stores/clock'
import { useHomeStore } from '../../../stores/home'
import { useLabourStore } from '../../../stores/labour'
import { convertTo12HourTime, getLocalTimeWithTimezoneOffset } from '../../../utils'
import Toast from 'react-native-toast-message'
import { getCurrentLocationAndCheckQuadrilateral } from '../../../helpers/geoFencingHelper'
import { ActivityIndicator } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { usePersonalStore } from '../../../stores/personalInfo'
import { Loading } from '../../../components/shared/navigator/Loading'

const ClockOut = ({ navigation, route }) => {
  const { params } = route

  const {
    mostRecentUserOnBoardings: Id,
    refresh,
    setClockOut,
    setClockIn,
    shiftid
  } = params
  const [currentTime, setCurrentTime] = useState(new Date())
  const [rating, setRating] = useState('')
  const clockstore = useclockstore()
  const homestore = useHomeStore()
  const labourStore = useLabourStore()
  const [loader, setLoader] = useState(false)
  const personalstore = usePersonalStore()
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    clockstore.fetchattendancelogkey(
      Id,
      shiftid,
      labourStore?.labourData?.employeeNumber,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
    clockstore.fetchdepartments(
      personalstore?.personalData?.entityId,
      homestore?.homeData?.laborSaverStoreID,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
  }, [])

  useEffect(() => {
    const selectedDepartmentDetails = clockstore?.departmentsData?.data?.find((item) => item.department_Focus == clockstore?.departmentsData?.currentFocusDepartmentId);
    setSelectedDepartment(selectedDepartmentDetails)
  }, [clockstore?.departmentsData?.data, clockstore?.departmentsData?.currentFocusDepartmentId])

  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })

  const shiftdetails = useMemo(() => {
    return labourStore.scheduleData?.shiftInfo?.find((item: any) => item.shiftID == shiftid)
  }, [labourStore.scheduleData, shiftid])


  const data = {
    EssUserOnboardingKey: Id,
    attendanceLogKey: clockstore.attendancelogkey,
    clockPunchTime: new Date().toISOString(),
    outType: 'OUT',
    Dept_focus: selectedDepartment?.department_Focus,
    Dept_LaborSaver: selectedDepartment?.department_Laborsaver,
    satisfaction: rating
  }

  const handleSubmit = async () => {
    // const flag =
    //   !homestore.homeData?.geofencingStatus &&
    //   homestore.homeData?.coordinateOneLatitude != null
    // if (flag) {
    //   const topLeft = [
    //     homestore.homeData.coordinateOneLatitude,
    //     homestore.homeData.coordinateOneLongitude
    //   ]
    //   const topRight = [
    //     homestore.homeData.coordinateTwoLatitude,
    //     homestore.homeData.coordinateTwoLongitude
    //   ]
    //   const bottomRight = [
    //     homestore.homeData.coordinateThreeLatitude,
    //     homestore.homeData.coordinateThreeLongitude
    //   ]
    //   const bottomLeft = [
    //     homestore.homeData.coordinateFourLatitude,
    //     homestore.homeData.coordinateFourLongitude
    //   ]
    //   try {
    //     setLoader(true)
    //     const empLocation = null
    //     const res = await getCurrentLocationAndCheckQuadrilateral(
    //       topLeft,
    //       topRight,
    //       bottomLeft,
    //       bottomRight,
    //       empLocation
    //     )
    //     if (res) {
    //       try {
    //         await clockstore.updateclockin(data)
    //         setClockOut(true)
    //         setClockIn(false)
    //         navigation.navigate('LabourScreen')
    //       } catch (error) { }
    //       console.log('Location in inside')
    //     } else {
    //       Toast.show({
    //         type: 'error',
    //         position: 'bottom',
    //         text1: t('Cannot submit Clock In from outside the store'),
    //         visibilityTime: 5000,
    //         autoHide: true,
    //         topOffset: 60
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // } else {
    try {
      await clockstore.updateclockin(data)
      setClockOut(true)
      setClockIn(false)
      navigation.navigate('LabourScreen')
    } catch (error) { }
    // }
  }
  const { t } = useTranslation()

  if (clockstore?.loading) return <Loading />

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {t('Clock Out')}
          </Text>
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#4FC7E8',
              width: '90%'
            }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                 fontFamily:fontPalette.primaryBold
              }}
            >
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View>
            <Text style={{ fontSize: 30, fontWeight: 'bold',fontFamily:fontPalette.primaryBold }}>
              {formattedTime}
            </Text>
            <CardSeparator />
            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,

              ]}
            >
              {t('Scheduled Shift')}
            </Text>

            <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular}}>
              {moment(shiftdetails?.date).format('MMM D')},{' '}
              {convertTo12HourTime(shiftdetails?.time_In)} -{' '}
              {convertTo12HourTime(shiftdetails?.time_Out)}
            </Text>
            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('store')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {homestore.homeData.storeName}
              </Text>
            </View>

            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('Department')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {/* {homestore.homeData.deptName} */}
                {selectedDepartment?.depName}

              </Text>
            </View>
            <View>
              <Text style={{ marginTop: 15, fontSize: 15, fontWeight: 'bold' ,fontFamily:fontPalette.primaryRegular}}>
                {t('Please tell us how your shift was by choosing one below.')}
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }}
              >
                <TouchableOpacity onPress={() => setRating('1')}>
                  <MaterialCommunityIcons
                    name="emoticon-frown-outline"
                    size={55}
                    color="#983500"
                    style={{ marginBottom: 5 }}
                  />
                  <View
                    style={{ alignItems: 'center', justifyContent: 'center' }}
                  >
                    {rating == '1' && <View style={styles.dot}></View>}
                  </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={() => setRating('2')}>
                  <MaterialCommunityIcons
                    name="emoticon-sad-outline"
                    size={55}
                    color="#EBA300"
                  />
                  <View
                    style={{ alignItems: 'center', justifyContent: 'center' }}
                  >
                    {rating == '2' && <View style={styles.dot}></View>}
                  </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating('3')}>
                  <MaterialCommunityIcons
                    name="emoticon-neutral-outline"
                    size={55}
                    color="#4E8EAA"
                  />
                  <View
                    style={{ alignItems: 'center', justifyContent: 'center' }}
                  >
                    {rating == '3' && <View style={styles.dot}></View>}
                  </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating('4')}>
                  <MaterialCommunityIcons
                    name="emoticon-happy-outline"
                    size={55}
                    color="#76D8D4"
                  />
                  <View
                    style={{ alignItems: 'center', justifyContent: 'center' }}
                  >
                    {rating == '4' && <View style={styles.dot}></View>}
                  </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating('5')}>
                  <MaterialCommunityIcons
                    name="emoticon-excited-outline"
                    size={55}
                    color="#2B9A49"
                  />
                  <View
                    style={{ alignItems: 'center', justifyContent: 'center' }}
                  >
                    {rating == '5' && <View style={styles.dot}></View>}
                  </View>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Card>
        {loader && <ActivityIndicator />}
        {!loader && (
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#9DD086',
              width: '90%',
              alignSelf: 'center'
            }}
            onPress={handleSubmit}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily:fontPalette.primaryRegular
              }}
            >
              {t('Submit Clock Out')}
            </Text>
          </TouchableOpacity>
        )}
      </View>

    </>
  )
}
export default ClockOut

const styles = StyleSheet.create({
  dot: {
    width: 5,
    height: 5,
    borderRadius: 5,
    backgroundColor: 'black',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
